import { apiRequest } from './client'

export type ReportTargetType = 'work' | 'comment' | 'user' | 'tip' | 'entry'

export interface CreateReportPayload {
  target_type: ReportTargetType
  target_id: number
  reason_code: string
  reason_detail?: string
}

export const reportsApi = {
  create: (payload: CreateReportPayload) =>
    apiRequest<{ id: number }>('/api/v1/reports', { method: 'POST', body: payload }),
}
